/**
 * Configuración compartida para driver.js.
 * Usada por useTour y useGuide para evitar deriva de textos y estilos.
 */
export const SHARED_DRIVER_CONFIG = {
  showProgress: true,
  popoverClass: 'fc-tour',
  nextBtnText: 'Siguiente',
  prevBtnText: 'Anterior',
  doneBtnText: 'Entendido',
  progressText: '{{current}} de {{total}}',
  // Separación entre el popover y el elemento resaltado. Sin esto el popover
  // queda pegado al recorte y, al ser ambos claros, se "mezclan" visualmente.
  popoverOffset: 16,
  // El elemento resaltado NO es interactivo durante la guía: el recorrido es
  // solo lectura/explicativo. Editar el formulario mientras la guía corre genera
  // estados inconsistentes. El usuario completa el formulario cuando la guía
  // termina (el modal queda abierto e interactivo).
  disableActiveInteraction: true,
} as const
